<template>
  <section class="container">
    <h1 v-if="$root.user" class="mb-4">Seleziona l’Articolo relativo la richiesta di parere</h1>
    <h1 v-else class="mb-4">Codice dei Contratti Pubblici Digitalizzato</h1>

    <div v-if="contentTree">
      <SearchBar :treeContainer="this.$root" @tree-updated="updateContentTree" />
      <hr>
      <div class="row">
        <!--<transition-group name="fade-transition" mode="out-in" tag="div" class="row" >-->
          <div class="col-12" v-for="node in contentTree.nodes" :key="node.id + '-' + treeKey">
            <div class="m-2 shadow rounded">
              <div class="p-3">
                <ContainerNode :contentTree="contentTree" :node="node" />
              </div>
            </div>
          </div>
        <!--</transition-group>-->
      </div>
    </div>

    <div v-else>
      <p>Caricamento articoli in corso...</p>
    </div>
  </section>
</template>

<script>
import { ref, onMounted } from 'vue'
import lodash from 'lodash'
import { ContentTree } from '../../classes/tree.js'
import ContainerNode from '../navigator/ContainerNode.vue'
import SearchBar from '../navigator/SearchBar.vue'
import { reactive } from 'vue';

export default {
  name: 'ArticlesView',
  components: { ContainerNode, SearchBar },

  data() {
    return {
      contentTree: undefined,
      treeKey: 0,
      isLoading: true,
      showNodes: false
    }
  },

  async created() {
    // se App.vue non ha ancora caricato i contenuti, aspetta
    if (!this.$root.contents) {
      await this.$root.fetchContents()
    }

    // blocca finché il caricamento non è finito
    if (this.$root.contentsLoading) {
      while (this.$root.contentsLoading) {
        await new Promise(resolve => setTimeout(resolve, 100))
      }
    }

    // ora i contenuti sono pronti, costruiamo l’albero locale
    this.buildArticlesTree()
  },
  async mounted() {
    if (this.contentTree) {
      this.contentTree.setUnfiltered()
      this.updateContentTree();

    }
  },
  methods: {
    buildArticlesTree() {
      // clona il contenuto globale per non modificarlo direttamente
      const virtualTree = lodash.cloneDeep(this.$root.contents)

      // filtra solo gli articoli validi
      const filteredArticles = {}
      for (const [key, value] of Object.entries(virtualTree.articles)) {
        if (!value.deleted_at && value.versions?.length > 0) {
          filteredArticles[value.id] = value
        }
      }
      virtualTree.articles = filteredArticles

      // funzione ricorsiva per filtrare le sezioni
      const filterSections = (sections, articles) => {
        const result = {}
        for (const [key, section] of Object.entries(sections)) {
          if (section.deleted_at) continue

          // verifica se la sezione ha articoli validi
          const hasArticles = Object.values(articles).some(a => a.section === section.id)

          // verifica se la sezione ha sottosezioni con articoli
          const childSections = Object.fromEntries(
            Object.entries(sections).filter(([k, s]) => s.parent === section.id)
          )
          const filteredChildSections = filterSections(childSections, articles)
          if (hasArticles || Object.keys(filteredChildSections).length > 0) {
            // include la sezione solo se ha articoli o figli con articoli
            result[key] = section
          }
        }
        return result
      }

      virtualTree.sections = filterSections(virtualTree.sections, virtualTree.articles)

      // costruisci l’albero usando la stessa classe globale
      this.contentTree = new ContentTree(virtualTree);
      /**this.$nextTick(() => {
        this.showNodes = true;
      })*/
      console.log(this.contentTree)
      console.log("Totale elementi:", countNodes([this.contentTree]));
    },
    updateContentTree() { //notifica Vue dell'aggiornamento dei nodi del contentTree
      /**if (this.contentTree) {
        console.log('ARTICLES VIEW - Aggiornamento nodi, treeKey:', this.treeKey);
        console.log('ARTICLES VIEW - Prima:', this.contentTree.nodes);
        this.contentTree.nodes = [...this.contentTree.nodes];
        console.log('ARTICLES VIEW - Dopo:', this.contentTree.nodes);
        this.treeKey++; //forza il refresh del DOM
      }*/
      if (this.$root.contentTree) {
        this.contentTree = lodash.cloneDeep(this.$root.contentTree)
        this.treeKey++
      }
    }
  }
}
</script>

<style scoped>
h1 {
  font-size: 1.8rem;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}
</style>
